import {
  EntityType,
  EntityTypesSupportingCustomSourceObject,
  EntityTypeSupportingPinnedFields,
} from "@mapmycustomers/shared/types/entity";
import { MapPersistedEntityColumns } from "@mapmycustomers/shared/types/map/types";

export const ENTITY_TYPES_SUPPORTING_PINNED_FIELDS: readonly EntityTypeSupportingPinnedFields[] = [
  EntityType.ACTIVITY,
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
];

export const SOURCE_OBJECT_ENTITY_TYPES = [
  EntityType.COMPANY,
  EntityType.PERSON,
] as const satisfies readonly EntityTypesSupportingCustomSourceObject[];

export type SourceObjectEntityType = (typeof SOURCE_OBJECT_ENTITY_TYPES)[number];

const RESERVED_KEYS = [...ENTITY_TYPES_SUPPORTING_PINNED_FIELDS, "actions", "engagement"] as const;

// Resolves to never, failing the export below, when a key of the persisted `fields` is not reserved
type AllPersistedFieldKeysReserved =
  keyof MapPersistedEntityColumns["fields"] extends (typeof RESERVED_KEYS)[number]
    ? readonly string[]
    : never;

// Keys of the persisted lists that a subtype key must never shadow
export const RESERVED_PINNED_LIST_KEYS: AllPersistedFieldKeysReserved = RESERVED_KEYS;
